module.exports = __webpack_public_path__ + "img/quest_icon_0001_poison.8af2aca9.png";